// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ORltA","placeholdersHeader":"styles_placeholdersHeader__1eMEQ","editorStyle":"styles_editorStyle__3EWEc","placeholdersBox":"styles_placeholdersBox__1aTQV"};